import { superAdminApi } from "../authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../../types/api";

const RESOURCE = "/super-admin/email-suppressions";

export interface EmailSuppression {
  id: number;
  email: string;
  reason: string;
  source: string;
  tenant_id: number | null;
  ses_message_id: string | null;
  suppressed_at: string;
  created_at: string;
  updated_at: string;
}

export interface EmailHealthWindow {
  sent: number;
  bounced: number;
  complained: number;
  bounce_rate: number | null;
  complaint_rate: number | null;
}

export interface EmailHealth {
  window_24h: EmailHealthWindow;
  window_7d: EmailHealthWindow;
  suppressions_total: number;
}

export interface EmailSuppressionListParams extends PaginationParams {
  email?: string;
  reason?: string;
  source?: string;
}

export const getEmailSuppressions = async (
  params?: EmailSuppressionListParams
): Promise<PaginatedApiResponse<EmailSuppression>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<EmailSuppression>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const createEmailSuppression = async (payload: {
  email: string;
  reason?: string;
}): Promise<ApiResponse<EmailSuppression>> => {
  const response = await superAdminApi.post<ApiResponse<EmailSuppression>>(
    RESOURCE,
    payload
  );

  return response.data;
};

export const deleteEmailSuppression = async (
  id: number
): Promise<ApiResponse<unknown>> => {
  const response = await superAdminApi.delete<ApiResponse<unknown>>(
    `${RESOURCE}/${id}`
  );

  return response.data;
};

export const importEmailSuppressions = async (
  file: File
): Promise<ApiResponse<unknown>> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await superAdminApi.post<ApiResponse<unknown>>(
    `${RESOURCE}/import`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return response.data;
};

export const getEmailHealth = async (): Promise<ApiResponse<EmailHealth>> => {
  const response = await superAdminApi.get<ApiResponse<EmailHealth>>(
    "/super-admin/email/health"
  );

  return response.data;
};
